import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import $ from 'jquery';
import Header from '../../components/dynamic_list/Header';
import Main from '../../components/dynamic_list/main';
import Changes from '../../components/dynamic_list/changes';
import HeaderSearch from '../../components/dynamic_list/header_search';
import Message from '../../components/common/message';
import { bindActionCreators } from 'redux';
import Loading from '../../components/common/loading';
import * as dynamicListActions from '../../actions/dynamic_list';
import constant from '../function/constants';

import toastr from 'toastr';
import SweetAlert from 'react-bootstrap-sweetalert';

class DynamicList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        list: [],
        item: []
      },
      create: false,
      value: '',
      delete: false,
      show: false,
      showIcon: false,
      listToDelete: '',
      itemToDelete: '',
      listId: '',
      listName: '',
      dataItem: [],
      dataItems: [],
      itemsToEdit: [],
      itemsId: [],
      itemsName: [],
      itemToEdit: '',
      isEdit: false,
      modalEditValue: '',
      itemIndex: '',
      showAlert: false,
      listAlertName: '',
      editModalTes: false,
      activate: false,
      showEdit: false,
      showDelete: false,
      itemId: '',
      itemName: '',
      addItemError: false,
      uid: '00',
      deleteindex: 0,
      disableListHover: false, // disable clicke over list item, on doing item modification
      isCancel: false, // Show sweet alert on cancel
      isSave: false, // Show sweet alert on save
      addItemError: false // Show tooltip error
    };
  }

  async componentDidMount() {
    await this.props.actions.getAllList({ test: 1 });
    this.props.actions.handleResetItems();
  }
  componentWillMount() {}
  componentWillUnmount() {
    this.props.actions.handleResetItems();
  }

  createInput = e => {
    if (!this.state.create) {
      this.setState({
        //  create: !this.state.create
        create: true
      });
    }

    let listInput = document.getElementById('fname');
    if (listInput) {
      listInput.focus();
    }

    window.scrollBy(0, 11110);
  };

  handleDataList = async value => {
    await this.props.actions.createList({
      name: value
    });

    if (this.props.status === 200) {
      if (this.props.datos) {
        //let name = JSON.parse(this.props.datos.name);
        let id = this.props.datos.id;
        let obj = {
          id: id,
          name: this.props.datos.name
        };
        //  this.props.lists.response.push(obj);
        this.setState({
          data: {
            ...this.state.data,
            list: [...this.state.data.list, obj]
          }
        });
        // toastr.options = constant.tostrOptions;
        // toastr.success(
        //   this.props.language.dynamicList.card.toastrLable.success,
        //   this.props.language.dynamicList.card.toastrLable.info
        // );
      }
    }
    if (this.props.statusFail === null) {
      toastr.options = constant.tostrOptions;
      toastr.success(
        this.props.language.dynamicList.card.toastrLable.success,
        this.props.language.dynamicList.card.toastrLable.info
      );
    } else {
      toastr.options = constant.tostrOptions;
      toastr.error(
        this.props.language.dynamicList.card.toastrLable.error,
        this.props.language.dynamicList.card.toastrLable.err
      );
    }
    //  await this.props.actions.getAllList({ test: 1 });
    if (!this.props.statusFail /*&& this.props.statusFail === 500*/) {
      await this.props.actions.doConcat();
    }
  };

  // Delete a list using sweet alert component
  handleDelete_sweet_alert = async e => {
    $('li').removeClass('bg-red');
    if (this.state.listToDelete) {
      await this.props.actions.deleteList(this.state.listToDelete);

      if (this.props.deletedList.datos.status === 200) {
        toastr.options = constant.tostrOptions;
        toastr.success(
          this.props.language.dynamicList.card.toastrLable.listDeleteSuccess,
          this.props.language.dynamicList.card.toastrLable.info
        );
        let newArr = this.state.data.list.filter(item => {
          return item.id !== parseInt(this.state.listToDelete);
        });

        this.setState({
          data: {
            ...this.state.data,
            list: [...newArr]
          },
          showAlert: false,
          listToDelete: '',
          listId: '',
          dataItem: [],
          listAlertName: ''
        });
      } else {
        toastr.options = constant.tostrOptions;
        toastr.error(
          this.props.language.dynamicList.card.toastrLable.deletError,
          this.props.language.dynamicList.card.toastrLable.err
        );
      }
    } else {
      let newArr = this.state.data.list.filter(item => {
        return item !== this.state.listToDelete;
      });

      this.setState({
        data: {
          ...this.state.data,
          list: [...newArr]
        },
        show: false,
        listToDelete: ''
      });
    }
    this.props.actions.handleResetItems();
  };

  // Delete an ittem using sweet alert
  handleDelete_item_with_sweet_alert = async e => {
    // testing from wich component we have to delete the item
    if (this.state.itemToDelete) {
      // Delete an item if the si button is clicked
      this.props.actions.handleDeleteItem(
        {
          itemId: this.state.itemToDelete,
          listId: this.state.listId
        },
        this.state.deleteindex
      );

      let newArr = [...this.state.dataItem].filter(item => {
        return item.name !== this.state.itemToDelete;
      });

      let newArrs = [...this.state.dataItems].filter(item => {
        return item.name !== this.state.itemName;
      });

      this.setState({
        dataItem: [...newArr],
        dataItems: [...newArrs],
        showAlert: false /*listToDelete: ''*/,
        showEdit: true,
        showDelete: true,
        disableListHover: true
      });
      if (this.state.itemToDelete[0] !== '0' && this.state.itemToDelete[1] == '0') {
      } else {
        this.setState({ itemsId: [...this.state.itemsId, parseInt(this.state.itemToDelete)] });
      }
      toastr.options = constant.tostrOptions;
      toastr.success(
        this.props.language.dynamicList.card.toastrLable.itemDeleteSuccess,
        this.props.language.dynamicList.card.toastrLable.info
      );

      //reset listId if there is all the item is deleted (it was a test. get a better solution later)
      if (this.state.dataItem.length === 0)
        this.setState({
          //  listId: '',
          listName: '',
          showEdit: true,
          showDelete: true
        });
    }
  };

  handleDelete = async e => {
    const isDelete = e.target.dataset.delete;
    // testing from wich component we have to delete the item
    if (!this.state.itemToDelete) {
      if (isDelete === 'si' && this.state.listToDelete) {
        if (/*this.state.listId ===*/ this.state.listToDelete) {
          await this.props.actions.deleteList(this.state.listToDelete);

          if (this.props.deletedList.datos.status === 200) {
            toastr.options = constant.tostrOptions;
            toastr.success(
              this.props.language.dynamicList.card.toastrLable.listDeleteSuccess,
              this.props.language.dynamicList.card.toastrLable.info
            );
            let newArr = this.state.data.list.filter(item => {
              return item.id !== parseInt(this.state.listToDelete);
            });

            this.setState({
              data: {
                ...this.state.data,
                list: [...newArr]
              },
              show: false,
              listToDelete: '',
              listId: '',
              dataItem: []
            });
          } else {
            toastr.options = constant.tostrOptions;
            toastr.error(
              this.props.language.dynamicList.card.toastrLable.deletError,
              this.props.language.dynamicList.card.toastrLable.err
            );
          }
        } else {
          let newArr = this.state.data.list.filter(item => {
            return item !== this.state.listToDelete;
          });

          this.setState({
            data: {
              ...this.state.data,
              list: [...newArr]
            },
            show: false,
            listToDelete: ''
          });
        }
      } else if (isDelete === 'no') {
        this.setState({
          show: false,
          listToDelete: ''
        });
      }
      // Delete an item if the si button is clicked
    } else {
      if (isDelete === 'si') {
        let newArr = this.state.dataItem.filter(item => {
          return item.name !== this.state.itemToDelete;
        });

        this.setState({
          dataItem: [...newArr],
          show: false
        });

        //reset listId if there is all the item is deleted (it was a test. get a better solution later)
        if (this.state.dataItem.length === 1)
          this.setState({
            listId: ''
          });
      } else {
        this.setState({
          show: false,
          listToDelete: ''
        });
      }
    }
  };

  // Handle close on escape
  handleCloseOnEscape = e => {
    this.setState({
      create: false
    });
  };

  /* show modal for both list and item component */
  handleShowModal = async e => {
    e.persist();
    let value = e.target.dataset.value;
    let namealert = e.target.dataset.namealert;
    let isNewItem = this.state.dataItem.map(item => item.name).includes(e.target.dataset.name);
    e.stopPropagation();
    if (e.target.dataset.isitem) {
      //------------------------------------------------------------------------
      if (isNewItem) {
        this.props.actions.handleDeleteItem(
          {
            itemId: e.target.dataset.value,
            listId: this.state.listId
          },
          e.target.dataset.deleteindex
        );
        let newArr = [...this.state.dataItem].filter(item => {
          return item.name !== e.target.dataset.name;
        });

        let newArrs = [...this.state.dataItems].filter(item => {
          return item.name !== e.target.dataset.name;
        });

        this.setState({
          dataItem: [...newArr],
          dataItems: [...newArrs],
          showAlert: false /*listToDelete: ''*/,
          showEdit: true,
          showDelete: true,
          disableListHover: true
        });
      } else {
        let classList = e.target.parentElement.parentElement.parentElement.classList;
        if (classList) {
          if (classList.contains('bg-red')) {
            classList.remove('bg-red');
            this.setState({
              itemsId: this.state.itemsId.filter(item => item != e.target.dataset.value),
              itemsName: this.state.itemsName.filter(item => item != e.target.dataset.name)
            });
            // reinitializing when there is no item to delete
            if (this.state.itemsId.length == 1) {
              this.setState({
                showEdit: false,
                showDelete: false,
                disableListHover: false,
                itemsName: [],
                itemsId: []
              });
            }
          } else {
            classList.add('bg-red');
            this.setState({
              showEdit: true,
              showDelete: true,
              disableListHover: true
            });
            if (e.target.dataset.name[0] !== '0' && e.target.dataset.name[1] !== '0') {
              this.setState({ itemsId: [...this.state.itemsId, parseInt(e.target.dataset.value)] });
              //  this.setState({ itemsId: [...this.state.itemsId] });
              //
              this.setState({ itemsName: [...this.state.itemsName, e.target.dataset.name] });
            } else {
              //  this.setState({ itemsId: [...this.state.itemsId, parseInt(e.target.dataset.value)] });
              this.setState({ itemsId: [...this.state.itemsId] });
            }
          }
        }
      }
      //   if (e.target.dataset.name[0] !== '0' && e.target.dataset.name[1] == '0') {
      //     this.setState({ itemsId: [...this.state.itemsId] });
      //   } else {
      //     this.setState({ itemsId: [...this.state.itemsId, parseInt(e.target.dataset.value)] });
      //   }
      // }
      //------------------------------------------------------------------------------
      this.setState({
        //  showAlert: true,
        itemToDelete: e.target.dataset.value,
        itemName: e.target.dataset.name,
        deleteindex: e.target.dataset.deleteindex
      });
    } else {
      try {
        await this.props.actions.getAllItemByList(e.target.dataset.value, true);
      } catch (e) {}
      if (this.props.hasitem.length > 0) {
        let classList = e.target.parentElement.parentElement.parentElement.classList;
        if (classList.contains('bg-red')) {
          classList.remove('bg-red');
        } else {
          classList.add('bg-red');
        }

        this.setState({
          showAlert: true,
          listToDelete: value, // alow us to display diferent message on both component
          itemToDelete: '',
          listAlertName: namealert
        });
      } else {
        // call delete list action
        await this.props.actions.deleteList(value);
        toastr.options = constant.tostrOptions;
        if (!this.props.deletedList.error) {
          toastr.success(
            this.props.language.dynamicList.card.toastrLable.listDeleteSuccess,
            this.props.language.dynamicList.card.toastrLable.info
          );
        } else {
          toastr.error(
            this.props.language.dynamicList.card.toastrLable.deletError,
            this.props.language.dynamicList.card.toastrLable.err
          );
        }
      }
    }
  };

  handleHideModal = e => {
    this.setState({
      show: false,
      itemToDelete: ''
    });
  };

  handleDeleteList = e => {
    this.setState({
      delete: !this.state.delete
    });
  };

  handlePropagation = e => {
    e.stopPropagation();
  };

  handleGetListId = async e => {
    //  if (!this.state.listId) {
    this.setState({
      listId: e.listId,
      listName: e.listName
    });
    //await this.props.actions.getAllItemByList(e.listId);
    //  }
    await this.props.actions.getAllItemByList(e.listId);
    this.setState({ create: false, listName: e.listName });
    //await this.props.actions.getAllItemByList(this.state.listId);
  };

  // add item and list id in dataItem array
  handleItemData = value => {
    const val = this.state.dataItem;
    val.push({
      id: this.state.listId,
      name: value
    });
    this.state.dataItems.push({ name: value });
    this.props.actions.concatItems({ id: this.state.uid + 1, name: value });
    this.setState({
      dataItem: val,
      uid: this.state.uid + 1
    });
  };

  // function to edit items
  handleHideModalEdit = e => {
    this.setState({
      isEdit: false,
      itemToEdit: ''
    });
  };

  handleShowModalEdit = e => {
    if (e.target.dataset.edit) {
      let classList = e.target.parentElement.parentElement.parentElement.classList;

      if (classList) {
        classList.add('_00');
      }
      this.setState({
        isEdit: true,
        itemToEdit: e.target.dataset.edit,
        itemIndex: e.target.dataset.editindex,
        itemId: e.target.dataset.itemid
      });
    }
  };

  // function to edit and item
  handleEditChange = e => {
    this.setState({
      modalEditValue: e.target.value
    });
  };

  // function to edit un item with sweet alert
  handleEdit = async e => {
    let obj = null;
    if (this.state.itemId.substring(0, 2) != '00') {
      obj = { id: this.state.itemId, name: e };
      this.setState({ itemsToEdit: [...this.state.itemsToEdit, obj] });
    }
    this.setState({
      //itemsToEdit: [...this.state.itemsToEdit, obj],
      showEdit: true,
      showDelete: true,
      disableListHover: true
    });
    await this.props.actions.handleEditItem(
      {
        listId: this.state.listId,
        itemId: this.state.itemId,
        itemName: e
      },
      this.state.itemIndex
    );
    this.setState({
      modalEditValue: ''
      //dataItem: []
      //showIcon: true
    });

    const updatedObject = {
      ...this.state.dataItem[this.state.itemIndex],
      name: e
    };
    //--------------------------------------------------------
    const newDataItem = [
      ...this.state.dataItem.slice(0, parseInt(this.state.itemIndex)),
      updatedObject,
      ...this.state.dataItem.slice(parseInt(this.state.itemIndex) + 1)
    ];
    //--------------------------------------------------------
    this.setState({
      //dataItem: [...newDataItem],
      //  dataItem: [],
      isEdit: false
    });
    // toastr.options = constant.tostrOptions;
    // toastr.success(
    //   this.props.language.dynamicList.card.toastrLable.itemEditSuccess,
    //   this.props.language.dynamicList.card.toastrLable.info
    // );
  };

  // function to get get back to the list component, reset the item component and display list input
  handleCancel = e => {
    this.setState({
      dataItem: [],
      itemsToEdit: [],
      listId: '',
      showIcon: false,
      listName: '',
      showEdit: false,
      showDelete: false,
      disableListHover: false,
      isCancel: false,
      isSave: false,
      showEdit: false,
      itemsName: []
    });
    this.props.actions.handleResetItems();
  };

  // function to save the item
  handleSaveItem = async e => {
    if (this.state.itemsId.length > 0) {
      await this.props.actions.handleDeleteItems({
        itemId: this.state.itemsId,
        listId: this.state.listId
      });
    }

    if (this.state.itemsToEdit.length > 0) {
      await this.props.actions.handleEditItemstest({
        listId: this.state.listId,
        itemId: this.state.itemId,
        itemName: this.state.itemsToEdit
      });
    }

    this.setState({ showIcon: false, /*listId: ''*/ listName: '', itemsToEdit: [], itemsName: [] });
    const data = this.state.dataItem.map(item => {
      return {
        name: item.name
      };
    });

    const obj = {
      listId: this.state.listId,
      items: this.state.dataItems
    };

    if (this.state.dataItems.length > 0) {
      await this.props.actions.createItem(obj);
    }
    this.setState({
      dataItem: [],
      listId: '',
      dataItems: [],
      uid: '00',
      showEdit: false,
      showDelete: false,
      itemsId: [],
      disableListHover: false,
      isSave: false
    });

    if (
      (this.props.datosItem.status === 200) |
      (this.props.editedItem.result.result == true) |
      (this.props.deletedItem.result.result == true)
    ) {
      toastr.options = constant.tostrOptions;
      toastr.success(
        this.props.language.dynamicList.card.toastrLable.change,
        this.props.language.dynamicList.card.toastrLable.info
      );
    }

    if (
      (this.props.datosItem.status != 200) |
      (!this.props.editedItem.result.result == true) |
      (!this.props.deletedItem.result.result == true)
    ) {
      //  if (this.state.dataItems.length > 0) {
      toastr.options = constant.tostrOptions;
      toastr.warning(
        this.props.language.dynamicList.card.toastrLable.notChange,
        this.props.language.dynamicList.card.toastrLable.err
      );
      //}

      this.setState({
        dataItem: [],
        listId: '',
        dataItems: [],
        uid: 0,
        showEdit: false,
        showDelete: false,
        itemsId: []
      });
    }

    this.props.actions.handleResetItems();
  };

  onCancel = () => {
    let x = document.getElementsByClassName('bg-red');
    let y = document.getElementsByClassName('_00');

    if (x.length > 0) {
      x[0].classList.remove('bg-red');
    }
    if (y.length > 0) {
      y[0].classList.remove('_00');
    }
    if (this.state.itemToEdit.length > 0) {
      this.setState({ showEdit: true });
    } else {
      {
        this.setState({ showEdit: false });
      }
    }
    this.setState({
      showAlert: false,
      isEdit: false,
      listName: '',
      //  showEdit: false,
      itemsName: [],
      itemsId: [],
      showEdit: false,
      showDelete: false
    });
  };

  handleShowIcon = e => {
    this.setState({ showIcon: true });
  };

  handleShowTooltip = e => {
    this.setState({ addItemError: true });
  };

  handleDisableListHover = () => {
    this.setState({ disableListHover: true, itemIcon: true });
  };

  // save changes with sweetalert
  handleSaveChanges = () => {
    this.setState({ isSave: true });
  };

  // Cancel changes with sweetalert
  handleCancelChanges = () => {
    if (
      this.state.itemsId.length > 0 ||
      this.state.itemsToEdit.length > 0 ||
      this.state.dataItems.length > 0
    ) {
      this.setState({ isCancel: true });
    } else {
      {
        this.setState({
          dataItem: [],
          listId: '',
          showIcon: false,
          listName: '',
          showEdit: false,
          showDelete: false,
          disableListHover: false,
          isCancel: false,
          isSave: false
        });
        this.props.actions.handleResetItems();
      }
    }
  };

  handleDisableCancelPopUp = () => {
    this.setState({ isCancel: false, isSave: false });
  };

  handleShowTooltip = e => {
    if (!this.state.listId) {
      this.setState({ addItemError: e });
    }

    if (typeof e === 'object') {
      e.stopPropagation();
      this.setState({ addItemError: false });
    }
  };

  handleHideTooltipGlobal = e => {
    this.setState({ addItemError: false });
  };

  showCancelOnTyping = e => {
    this.setState({
      showIcon: true,
      showAlert: false /*listToDelete: ''*/,
      //showEdit: true,
      //showDelete: true,
      disableListHover: true
    });
  };

  render() {
    // the setting object is obtained which we use for the configuration
    const obj = JSON.parse(this.props.setting.value);
    // condition done to see if the setting was done
    if (this.props.setting) {
      let container = '';
      if (this.props.status === 401) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (this.props.status === 200) {
        container = (
          <div
            className="main-container dynamic-list-container"
            onClick={this.handleHideTooltipGlobal}
          >
            <HeaderSearch
              filters={this.props.filters}
              handleSubmit={this.handleSubmit}
              language={this.props.language}
            />
            <Header language={this.props.language.dynamicList} />
            <Main
              handleClick={this.createInput}
              isCreate={this.state.create}
              data={this.state.data}
              lists={this.props.lists}
              handleChange={this.handleChange}
              keyPress={this.keyPress}
              value={this.state.value}
              handleDataList={this.handleDataList}
              handleDelete={this.handleDelete}
              handleShowModal={this.handleShowModal}
              list={this.state.data.list}
              handleGetListId={this.handleGetListId}
              listId={this.state.listId}
              listName={this.state.listName}
              handleItemData={this.handleItemData}
              dataItem={this.state.dataItem}
              handleShowModalEdit={this.handleShowModalEdit}
              handleCancel={this.handleCancel}
              handleSaveItem={this.handleSaveItem}
              language={this.props.language.dynamicList}
              loading={this.props.loading}
              items={this.props.items}
              onEscape={this.handleCloseOnEscape}
              showIcon={this.handleShowIcon}
              showItemIcon={this.state.showIcon}
              addItemError={this.state.addItemError}
              showEdit={this.state.showEdit}
              showDelete={this.state.showDelete}
              disableListHover={this.state.disableListHover}
              handleDisableListHover={this.handleDisableListHover}
              handleSaveChanges={this.handleSaveChanges}
              handleCancelChanges={this.handleCancelChanges}
              isCancel={this.state.isCancel}
              handleShowTooltip={this.handleShowTooltip}
              showCancelOnTyping={this.showCancelOnTyping}
            />
            {this.state.showAlert && (
              <SweetAlert
                danger
                showCancel
                confirmBtnText={this.props.language.dynamicList.card.toastrLable.confirm}
                title={
                  <div>
                    <span className="modal-title">
                      {' '}
                      {`¿${this.props.language.dynamicList.card.toastrLable.question} ${
                        !this.state.itemToDelete
                          ? this.props.language.dynamicList.card.toastrLable.list
                          : this.props.language.dynamicList.card.toastrLable.item
                      } ${
                        !this.state.itemToDelete ? this.state.listAlertName : this.state.itemName
                      }?`}
                    </span>
                  </div>
                }
                closeOnClickOutside={true}
                cancelBtnText={this.props.language.dynamicList.card.toastrLable.cancel}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                onConfirm={
                  !this.state.itemToDelete
                    ? this.handleDelete_sweet_alert
                    : this.handleDelete_item_with_sweet_alert
                }
                onCancel={this.onCancel}
              >
                {!this.state.itemToDelete ? (
                  <div className="tilte-modal-box">
                    <h5>{this.props.language.dynamicList.card.toastrLable.caution} </h5>
                    <h5>{this.props.language.dynamicList.card.toastrLable.caution1}</h5>
                  </div>
                ) : (
                  <div className="tilte-modal-box">
                    <h5>
                      {this.props.language.dynamicList.card.toastrLable.deleteItem}{' '}
                      {this.state.itemName}
                    </h5>
                  </div>
                )}{' '}
              </SweetAlert>
            )}{' '}
            {this.state.isEdit && (
              <SweetAlert
                input
                inputType="text"
                showCancel
                closeOnClickOutside={true}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                cancelBtnText={this.props.language.dynamicList.card.toastrLable.cancel}
                title={
                  <span className="edit-list">
                    {this.props.language.dynamicList.card.toastrLable.editItem}{' '}
                    {this.state.itemToEdit}
                  </span>
                }
                defaultValue={this.state.itemToEdit}
                onConfirm={this.handleEdit}
                onCancel={this.onCancel}
              />
            )}
            {this.state.isCancel || this.state.isSave ? (
              <SweetAlert
                warning
                showCancel
                confirmBtnText={this.props.language.dynamicList.card.toastrLable.confirm}
                title={
                  <div>
                    <span className="modal-title">
                      {' '}
                      {`¿ ${
                        this.state.isCancel
                          ? this.props.language.dynamicList.card.toastrLable._cancel
                          : this.props.language.dynamicList.card.toastrLable.save
                      } ${this.state.listName}
                      ?`}
                    </span>
                    <Changes
                      dataItem={this.state.dataItem}
                      itemsToEdit={this.state.itemsToEdit}
                      itemsName={this.state.itemsName}
                      language={this.props.language.dynamicList}
                    />
                  </div>
                }
                closeOnClickOutside={true}
                cancelBtnText={this.props.language.dynamicList.card.toastrLable.cancel}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                onConfirm={this.state.isCancel ? this.handleCancel : this.handleSaveItem}
                onCancel={this.state.isCancel ? this.handleDisableCancelPopUp : this.handleCancel}
              />
            ) : (
              ''
            )}
          </div>
        );
      }
      // the 500 status of the application
      else if (this.props.status === 500) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return <section className="main"> {container} </section>;
    }
    // in case the setting is not loaded
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.dynamicList.datos,
  lists: state.reducer.dynamicList.lists,
  items: state.reducer.dynamicList.items,
  editedItem: state.reducer.dynamicList.editedItem,
  deletedItem: state.reducer.dynamicList.deletedItem,
  deletedList: state.reducer.dynamicList.delete,
  datosItem: state.reducer.dynamicList.item.datos,
  hasitem: state.reducer.dynamicList.items.hasitem,
  loading: state.reducer.dynamicList.loading,
  status: state.reducer.dynamicList.status,
  statusFail: state.reducer.dynamicList.statusFail,
  language: state.reducer.dashboard.language
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(dynamicListActions, dispatch)
});

DynamicList.propTypes = {
  datos: PropTypes.object,
  loading: PropTypes.bool,
  deletedList: PropTypes.object,
  status: PropTypes.number,
  language: PropTypes.object,
  datosItem: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicList);



// WEBPACK FOOTER //
// ./source/client/containers/dynamic_list/index.jsx